import { css } from 'styled-components';

export const mediaMaxWidth = (width) => (...args) =>
  css`
    @media (max-width: ${width}px) {
      ${css(...args)};
    }
  `;
